import { apiService } from './apiService';
import { PartnerTask } from '../types/partner';

class TaskService {
  async getTasks(partnerId: string): Promise<PartnerTask[]> {
    try {
      const response = await apiService.get<PartnerTask[]>(`/partner/${partnerId}/tasks`);
      return response.data ?? [];
    } catch (err) {

      return [];
    }
  }

  async saveTasks(partnerId: string, tasks: PartnerTask[]): Promise<boolean> {
    try {
      await apiService.put(`/partner/${partnerId}/tasks`, tasks);
      return true;
    } catch (err) {

      return false;
    }
  }
}

export const taskService = new TaskService();
export default taskService;
